<template>
    <vx-card  slot="no-body" :title="$t('KPU.Admin.Title')" class="text-center greet-user mb-5" v-show="$auth.checkRoles(bsgRoles.admins)">
      <menu-control :items="items">
      </menu-control>
    </vx-card>
</template>
<script>

import bsgRoles from './../../roles.js'
import menuControl from '@/app/shared/components/lists/menu.vue'

export default {
  components: {
    menuControl
  },
  data() {
    return {
      bsgRoles,
      items : [ 
        {
          roles : bsgRoles.admins,
          icon : "LockIcon",
          to : "/bsg/kpu/admin/keyprojects",
          i18nTitle : "KPU.KeyProject.Title"
        },
        {
          roles : bsgRoles.admins,
          icon : "LockIcon",
          to : "/bsg/kpu/admin/keyprojecttypes",
          i18nTitle : "KPU.KeyProjectType.Title"
        }
      ]
    }
  }
};
</script>